import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-096bb7fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-col page" }
const _hoisted_2 = { class: "flex-row group" }
const _hoisted_3 = { class: "flex-col section_2" }
const _hoisted_4 = { class: "flex-col items-center section_3" }
const _hoisted_5 = { class: "image-container" }
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "user" }
const _hoisted_9 = { class: "user" }
const _hoisted_10 = { class: "group_1" }
const _hoisted_11 = { class: "section_4" }
const _hoisted_12 = ["src"]
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "user" }
const _hoisted_15 = { class: "user" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("发送")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_ctx.comment.avatar === null || _ctx.comment.avatar ==='')
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: this.defaultAvatar,
                  alt: "",
                  class: "comment_avatar"
                }, null, 8, _hoisted_6))
              : (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: _ctx.comment.avatar,
                  alt: "",
                  class: "comment_avatar"
                }, null, 8, _hoisted_7)),
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.comment.nickName), 1),
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.comment.by1), 1),
            _createVNode(_component_van_icon, {
              name: "share-o",
              class: "user",
              onClick: _ctx.getShareInfo
            }, null, 8, ["onClick"]),
            _createVNode(_component_van_field, {
              "model-value": _ctx.comment.comment,
              autosize: "",
              type: "textarea",
              rows: "4",
              readonly: ""
            }, null, 8, ["model-value"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_van_image, {
                src: _ctx.commentIcon,
                alt: "",
                class: "comment_icon"
              }, null, 8, ["src"]),
              _createVNode(_component_van_list, {
                class: "van-list-container",
                loading: _ctx.loading,
                "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loading) = $event)),
                offset: "10",
                finished: _ctx.finished,
                "finished-text": "没有更多了",
                onLoad: _ctx.onLoad
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.answerCommentList, (item) => {
                    return (_openBlock(), _createElementBlock("div", { key: item }, [
                      _createElementVNode("div", null, [
                        (item.avatar === null || item.avatar ==='')
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: this.defaultAvatar,
                              alt: "",
                              class: "comment_avatar"
                            }, null, 8, _hoisted_12))
                          : (_openBlock(), _createElementBlock("img", {
                              key: 1,
                              src: item.avatar,
                              alt: "",
                              class: "comment_avatar"
                            }, null, 8, _hoisted_13)),
                        _createElementVNode("span", _hoisted_14, _toDisplayString(item.nickName), 1),
                        _createElementVNode("span", _hoisted_15, _toDisplayString(item.by1), 1)
                      ]),
                      _createVNode(_component_van_field, {
                        "model-value": item.answer,
                        autosize: "",
                        type: "textarea",
                        rows: "1",
                        readonly: ""
                      }, null, 8, ["model-value"])
                    ]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["loading", "finished", "onLoad"]),
              _createVNode(_component_van_cell_group, {
                inset: "",
                class: "bottom-nav"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_field, {
                    class: "send_comment",
                    style: { height: '6vh' },
                    modelValue: _ctx.answer,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.answer) = $event)),
                    autosize: "",
                    type: "textarea",
                    center: "",
                    placeholder: "友善回复"
                  }, {
                    button: _withCtx(() => [
                      _createVNode(_component_van_button, {
                        size: "small",
                        type: "primary",
                        class: "send_btn",
                        onClick: _ctx.answerComment
                      }, {
                        default: _withCtx(() => [
                          _hoisted_16
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ])
  ]))
}